class IChoseGuthrieFooter extends DrupalBehavior {

  onContent(context) {
    const self = this;
    $('a.top-toggle', context).on('click', function(event) {
      const $toggle = $(this);
      if ($toggle.attr('href') !== '') {
        event.preventDefault();
        const hash = $toggle.attr('href');
        $('html, body').animate({
          scrollTop: 0
        }, 0, function(){
          window.location = window.location + hash;
        });
      }
    });
    $('footer', context).each(function(){
      self.$footer = $(this);
    });
    $('.top-toggle', context).each(function(){
      self.$button = $(this);
    });
  }

  onReady(document) {
    super.onReady(document);
    const self = this;
    window.addEventListener('scroll', function() {
      if (self.$footer && self.$button) {
        if (window.pageYOffset + window.innerHeight >= self.$footer.offset().top + self.$button.outerHeight()) {
          self.$button.addClass('active');
        } else {
          self.$button.removeClass('active');
        }
      }
    });
  }
  
}
  
DrupalBehavior.register('guthrie_theme.components', 'i-chose-guthrie-footer', IChoseGuthrieFooter);  